import { motion } from "framer-motion";

export default function AgentLoading() {
    return (
        <section className="flex flex-col gap-6" data-testid="agent1-loading-section">
            <div className="flex items-center gap-3">
                <motion.span
                    animate={{
                        opacity: [0.3, 1, 0.3],
                        boxShadow: [
                            "0 0 0 0 rgba(0,245,212,0.35)",
                            "0 0 0 8px rgba(0,245,212,0)",
                            "0 0 0 0 rgba(0,245,212,0.35)",
                        ],
                    }}
                    transition={{ duration: 1.6, repeat: Infinity, ease: "easeInOut" }}
                    className="h-2 w-2 rounded-full bg-[#00F5D4]"
                />
                <span className="font-mono text-xs uppercase tracking-[0.32em] text-[#00F5D4] sp-glow-mint">
                    Agent 1 is scanning your content…
                </span>
            </div>

            <div className="flex flex-col gap-4">
                <span className="text-[10px] uppercase tracking-[0.32em] text-[#8A93A6]">
                    titles
                </span>
                <div className="grid gap-4 sm:grid-cols-3">
                    {[0, 1, 2].map((i) => (
                        <SkeletonCard key={`t-${i}`} delay={i * 0.12} />
                    ))}
                </div>
            </div>

            <div className="flex flex-col gap-4">
                <span className="text-[10px] uppercase tracking-[0.32em] text-[#8A93A6]">
                    captions
                </span>
                <div className="grid gap-4 sm:grid-cols-3">
                    {[0, 1, 2].map((i) => (
                        <SkeletonCard key={`c-${i}`} delay={0.36 + i * 0.12} tall />
                    ))}
                </div>
            </div>
        </section>
    );
}

function SkeletonCard({ delay = 0, tall = false }) {
    return (
        <motion.div
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay }}
            className={[
                "sp-shimmer relative overflow-hidden rounded-xl border border-[#1F2A40] bg-[#111726]",
                tall ? "h-36" : "h-24",
            ].join(" ")}
        >
            <div className="flex flex-col gap-3 p-5">
                <div className="h-3 w-16 rounded-full bg-[#1A2235]" />
                <div className="h-4 w-full rounded-full bg-[#1A2235]" />
                {tall && <div className="h-4 w-3/4 rounded-full bg-[#1A2235]" />}
                {tall && <div className="h-4 w-1/2 rounded-full bg-[#1A2235]" />}
            </div>
        </motion.div>
    );
}
